import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


interface CommonState {
  isLMSUser: boolean | null
  isLoanExpired: boolean
  foreCloseReason:any,
  phoneNumbder : string,
  isBFLLoan : boolean,
  // Add the index signature for dynamic properties
  [key: string]: any;  // This allows any new key with any value to be added
  isLoanCompleted : boolean
  isLMSUserDashboard : boolean
}



// Define the initial state using that type
const initialState : CommonState = {
    isLMSUser:null,
    isLoanExpired:false,
    foreCloseReason:{},
    phoneNumber : '',
    isBFLLoan : false,
    isLoanCompleted : false,
    isLMSUserDashboard: false
}

export const commonSlice = createSlice({
  name: 'commonDetails',
  initialState,
  reducers: {
    clearCommonStore: (state) => {
      state.isLMSUser = null;
      state.isLoanExpired = false;
      state.foreCloseReason = {};
      state.phoneNumber = '';
      state.isLoanCompleted = false;
      state.isLMSUserDashboard = false;
      // Reset any other properties as needed
    },
    updateLoanExpiryState: (state, action: PayloadAction<Pick<CommonState, 'loanExpired'>>) => {
      state.isLoanExpired = action.payload.loanExpired;
    },
    updateForeCloseReason: (state, action: PayloadAction<Pick<CommonState, 'foreCloseReason'>>) => {
      state.foreCloseReason = action.payload;
    },
    updateisLMSUser: (state, action: PayloadAction<Pick<CommonState, 'isLMSUser'>>) => {
      state.isLMSUser = action.payload.isLMSUser;
    },
    updatePhoneNumber: (state, action: PayloadAction<Pick<CommonState, 'phoneNumber'>>) => {
      state.phoneNumber = action.payload.phoneNumber;
    },
     updateBFLCheck: (state, action: PayloadAction<Pick<CommonState, 'isBFLLoan'>>) => {
      state.isBFLLoan = action.payload.isBFLLoan;
    },
    updateIsLoanCompleted: (state, action: PayloadAction<Pick<CommonState, 'isLoanCompleted'>>) => {
      state.isLoanCompleted = action.payload.isLoanCompleted;
    },
    updateLMSUserDashboard: (state, action: PayloadAction<Pick<CommonState, 'isLMSUserDashboard'>>) => {
      state.isLMSUserDashboard = action.payload.isLMSUserDashboard;
    },
  },
});

export const { clearCommonStore,updateLoanExpiryState,updateForeCloseReason,updateisLMSUser, updatePhoneNumber , updateBFLCheck, updateIsLoanCompleted,updateLMSUserDashboard } = commonSlice.actions


export default commonSlice.reducer